import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { MemberService } from '../services/member.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { PdfService } from '../services/pdf.service';
import { Constants } from '../../assets/constants';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent implements OnInit {
  showDisclaimer: boolean = false;
  showPdfViewer: boolean = false;
  isPdfLoaded: boolean = false;
  isLoadingPdf: boolean = false;
  memberEmailForm: any;
  todaysDate: any;
  public memberDetails!: any;
  public showEmail: boolean = false;
  public isEmailSuccessful: boolean = false;
  public isErrorSendingEmail: boolean = false;
  public isCompassUserError: boolean = false;
  public compassUserErrorMessage: string = '';
  public isErrorFetchingPDF: boolean = false;
  public pdfFetchErrorMessage: string = '';
  public selectedProduct: any;
  public modalOptions: NgbModalOptions;
  public constants = Constants;
  closeResult: string;
  pdfSourcePath!: string;
  private blob!: Blob;

  constructor(
    private memberService: MemberService,
    private activatedRoute: ActivatedRoute,
    private cookieService: CookieService,
    private modalService: NgbModal,
    private pdfService: PdfService,
    private router: Router
  ) {
    this.todaysDate = formatDate(new Date(), 'yyyy/MM/dd', 'en');
    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
    };
    this.closeResult = '';
  }

  ngOnInit(): void {
    this.activatedRoute.data.subscribe((data) => {
      if (
        Object.keys(this.memberService.selectedProductCache()).length === 0 &&
        JSON.parse(this.cookieService.get('selected_product'))
      ) {
        this.selectedProduct = JSON.parse(
          this.cookieService.get('selected_product')
        );
      } else {
        this.selectedProduct = this.memberService.selectedProductCache();
      }

      this.memberDetails = data.routeResolver;
      this.memberService.cacheMemberInfo(this.memberDetails);
      this.memberEmailForm = new FormGroup({
        memberEmail: new FormControl(this.memberDetails.Email, [
          Validators.pattern(
            '^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,4})+$'
          ),
        ]),
      });
    });
  }

  showEmailPopUp(content: any) {
    this.showEmail = !this.showEmail;
    this.modalService.open(content, this.modalOptions).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  toggleDisclaimer() {
    this.showDisclaimer = !this.showDisclaimer;
  }

  togglePdfViewer() {
    this.showPdfViewer = !this.showPdfViewer;

    // If showing PDF viewer and PDF hasn't been loaded yet, fetch it
    if (this.showPdfViewer && !this.isPdfLoaded && !this.isLoadingPdf) {
      this.loadPdf();
    }
  }

  closePdfError() {
    this.isErrorFetchingPDF = false;
    this.showPdfViewer = false;
  }

  private loadPdf() {
    this.isLoadingPdf = true;
    this.pdfService.getPDF(this.selectedProduct.FundId).subscribe(
      (response) => {
        this.isErrorFetchingPDF = false;
        this.blob = new Blob([response], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(this.blob);
        this.pdfSourcePath = fileURL;
        this.isPdfLoaded = true;
        this.isLoadingPdf = false;
      },
      (e) => {
        this.isErrorFetchingPDF = true;
        this.isLoadingPdf = false;
        if (
          e.error &&
          typeof e.error === 'string' &&
          e.error.indexOf('zzretailcompasssupport@aforbes.com') > -1
        ) {
          this.isCompassUserError = true;
          this.compassUserErrorMessage = e.error;
        } else {
          this.isCompassUserError = false;
        }
        console.error('Error', e);
      }
    );
  }

  viewProductInfo() {
    this.router.navigate(['/product-selection']);
  }
  sendEAC() {
    this.pdfService
      .emailPDF(
        this.selectedProduct.FundId,
        this.memberEmailForm.controls.memberEmail.value
      )
      .subscribe(
        (resp) => {
          this.isEmailSuccessful = true;
          this.isErrorSendingEmail = false;
        },
        (e) => {
          this.isErrorSendingEmail = true;
          this.isEmailSuccessful = false;
          if (
            e.error &&
            typeof e.error === 'string' &&
            e.error.indexOf('zzretailcompasssupport@aforbes.com') > -1
          ) {
            this.isCompassUserError = true;
            this.compassUserErrorMessage = e.error;
          } else {
            this.isCompassUserError = false;
          }
        }
      );
  }
}
